// Environment configuration
export const config = {
  // Backend API
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000/api',
  
  // VideoSDK.live
  videoSdkToken: import.meta.env.VITE_VIDEOSDK_TOKEN || '',
  
  // Google Cloud Storage
  gcs: {
    bucketName: import.meta.env.VITE_GCS_BUCKET_NAME || '',
    projectId: import.meta.env.VITE_GCS_PROJECT_ID || ''
  },
  
  // Environment mode
  envMode: import.meta.env.VITE_ENV_MODE || 'development',
  isDevelopment: import.meta.env.VITE_ENV_MODE === 'development',
  isProduction: import.meta.env.VITE_ENV_MODE === 'production',
  
  // Auth
  authStorageKey: import.meta.env.VITE_AUTH_STORAGE_KEY || 'authToken',
  
  // Video constraints
  video: {
    maxDuration: 120, // 2 minutes in seconds
    aspectRatio: 16/9,
    maxFileSize: 100 * 1024 * 1024, // 100MB
    resolution: {
      width: { ideal: 1920 },
      height: { ideal: 1080 }
    }
  }
};

// Get auth token if user is logged in
export const getAuthToken = () => {
  return sessionStorage.getItem('foh_user_token');
};

// Set auth token
export const setAuthToken = (token) => {
  if (token) {
    sessionStorage.setItem('foh_user_token', token);
  } else {
    sessionStorage.removeItem('foh_user_token');
  }
};
